// extracted by mini-css-extract-plugin
export default {"button":"list_button__SoN5w"};